var _path, _path2, _path3, _mask, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30083 14.8657V23.3267C11.4517 25.8365 20.1142 29.3502 29.4704 23.3267V14.8657M2 12.5182L18.7364 18.8412L35.4205 12.5599L18.7364 5.61798L2 12.5182Z",
    stroke: "#2E2E2E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7949 13.5551V25.2495",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9551 31.0175V34.3818",
    stroke: "#2E2E2E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_44981_9417",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.71964,
    height: 5.71964,
    rx: 0.953273,
    transform: "matrix(0.707107 -0.707106 0.707107 0.707106 29.9111 27.7443)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.71964,
    height: 5.71964,
    rx: 0.953273,
    transform: "matrix(0.707107 -0.707106 0.707107 0.707106 29.9111 27.7443)",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-4-inside-1_44981_9417)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/Education.a3b9cd43faeffccc116f6b44ffdeac4c.svg";
export { ForwardRef as ReactComponent };